<div class="newsletter-wrapper">
  <h1
        class="display-4 text-uppercase text-center"
        style="color: #252525"
      >
        Newsletter
      </h1>
  <!-- Loading -->
  @if(loading){
  <div class="loading">Cargando newsletters...</div>
  } @if(error){
  <!-- Error -->
  <div class="error">
    Error al cargar los posts.
    <button (click)="retryLoadPosts()">Reintentar</button>
  </div>
  }

  <!-- Carousel -->
  @if(!loading && !error){
  <p-carousel
    [value]="newsletters"
    [numVisible]="3"
    [numScroll]="3"
    [responsiveOptions]="responsiveOptions"
    circular="true"
    autoplayInterval="8000"
    class="newsletter-carousel"
  >
    <ng-template pTemplate="item" let-post>
      <div class="post-card">
        <!-- TITULO -->
        <h2 class="post-title">{{ post.name }}</h2>

        <!-- DESCRIPCIÓN LIMPIA -->
        <p class="post-description">{{ post.description }}</p>

        <!-- LINK -->
        <a class="post-link" [href]="post.link" target="_blank">
          Leer en Substack →
        </a>
      </div>
    </ng-template>
  </p-carousel>
  }
</div>
